// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__YKHjL","pageItem":"pagination_pageItem__vbJ7o","pageLink":"pagination_pageLink__jHS0Q","active":"pagination_active__CP7Xw"};